import React from 'react';

import { Title } from '@gerdau/hefesto';

import { StepPropsRequestResult } from '../types';
import UserData from '../UserData';
import { useUserEvaluationContext } from '../../../providers/userEvaluation.provider';
import {
  UserEvaluationContainer,
  UserEvaluationBox,
  UserEvaluationRow,
  UserEvaluationRowWithColumn,
  UserEvaluationLink,
  UserEvaluationStrong,
  UserEvaluationTitle
} from '../styles';

const RequestResult: React.FC<StepPropsRequestResult> = ({
  currentScenario
}) => {
  const { userData } = useUserEvaluationContext();
  return (
    <UserEvaluationContainer>
      <UserEvaluationBox>
        <UserEvaluationRow>
          <header>
            <UserEvaluationTitle>
              <Title level={1}>
                {currentScenario === 'success'
                  ? 'Solicitação de cadastro aprovada'
                  : 'Solicitação de cadastro rejeitada'}
              </Title>
            </UserEvaluationTitle>
          </header>

          {currentScenario === 'success' && (
            <p className="item">
              A solicitação de cadastro foi aprovada com sucesso. A partir de
              agora, {userData!.companyName} terá acesso à área do cliente.
            </p>
          )}
        </UserEvaluationRow>

        <UserEvaluationRow>
          <UserData user={userData!} showHeader={true} />
        </UserEvaluationRow>

        <UserEvaluationRow>
          <p className="last">
            Em caso de dúvida ou suporte, entre em contato através dos canais de
            ajuda:
          </p>
        </UserEvaluationRow>

        <UserEvaluationRowWithColumn>
          <div>
            <p className="item">Telefone</p>
            <p className="item">
              <UserEvaluationStrong>0800 722 3322</UserEvaluationStrong>
            </p>
          </div>

          <div>
            <p className="item">Email</p>
            <p className="item">
              <UserEvaluationLink>
                suportegerdaumais@gerdau.com.br
              </UserEvaluationLink>
            </p>
          </div>
        </UserEvaluationRowWithColumn>
      </UserEvaluationBox>
    </UserEvaluationContainer>
  );
};

export default RequestResult;
